import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons"; //library only has solid icon
import { faEnvelope as solidEnvelope } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import "../scss/_contact.scss";

// import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";

// const mapStyle{
//     height: "400px",
//     width: "80%"
// };

// const center ={
//     lat: 44.645700,
//     lng: -63.572780
// };

function Contact() {
    const { t } = useTranslation();

    const [value, setValue] = useState({
        name: "",
        email: "",
        details: "",
        file: null,
    });

    const [errors, setErrors] = useState({});

    const handleChange = (element) => {
        const { name, value, files } = element.target;
        setValue((prevValue) => ({
            ...prevValue,
            [name]: files ? files[0] : value,
        }));
    };

    const validateForm = () => {
        const errors = {};
        if (!value.name) {
            errors.name = "Name is required";
        }
        if (!value.email) {
            errors.email = "Email is required";
        }
        if (!value.details) {
            errors.details = "Details are required";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const navigate = useNavigate();
    const goToSubmissionPage = () => {
        navigate("/Submission");
    };

    function sendEmail(element) {
        element.preventDefault();
        if (!validateForm()) {
            return;
        }

        const template = {
            from_name: value.name,
            email: value.email,
            message: value.details,
            // file: value.file
        };

        emailjs
            .send(
                process.env.REACT_APP_SERVICE_ID,
                process.env.REACT_APP_CONTACT_TEMPLATE_ID,
                template,
                process.env.REACT_APP_OPTIONS
            )
            .then(() => {
                goToSubmissionPage();
                setValue({
                    name: "",
                    email: "",
                    details: "",
                    // file: null
                });
            });
    }

    // const contactMap = withScriptjs(withGoogleMap((props) =>
    //     <GoogleMap
    //         defaultZoom={8}
    //         defaultCenter={{lat: 44.645700, lng: -63.572780}}>
    //             {props.isMarkerShown && <Marker position={{lat: 44.645700, lng: -63.572780}}/>}
    //     </GoogleMap>
    // ))

    return (
        <div className="contact">
            <div className="contact-spline">
                <h1>{t("contactUs")}</h1>
            </div>
            <div className="contact-bottom">
                <div className="contact-bottom-left">
                    <h1 className="text">{t("contactTitle")}</h1>
                    <p className="text">{t("contactDescription")}</p>
                    <h4>{t("contact")}</h4>
                    <div className="contact-bottom-left-buttonBox">
                        <button className="button phone">
                            <FontAwesomeIcon icon={faPhone} />
                        </button>
                        <p>&#124;</p>
                        <button className="button email">
                            <a href="mailto:hci4goodresearch@gmail.com">
                                <FontAwesomeIcon icon={faEnvelope} />
                            </a>

                            <a href="mailto:hci4goodresearch@gmail.com">
                                hci4goodresearch@gmail.com
                            </a>
                        </button>
                    </div>
                </div>
                <div className="contact-bottom-right">
                    <h3>{t("contactFormTitle")}</h3>
                    <form
                        className="contact-bottom-right-form"
                        onSubmit={sendEmail}
                    >
                        <input
                            name="name"
                            type="text"
                            placeholder={t("namePlaceholder")}
                            className="formBoxes"
                            onChange={handleChange}
                        />
                        {errors.name && <p className="error">{errors.name}</p>}
                        <input
                            name="email"
                            type="email"
                            placeholder={t("emailPlaceholder")}
                            className="formBoxes"
                            onChange={handleChange}
                        />
                        {errors.email && (
                            <p className="error">{errors.email}</p>
                        )}
                        <input
                            name="details"
                            placeholder="Details"
                            className="formBoxes details"
                            onChange={handleChange}
                        />
                        {errors.details && (
                            <p className="error">{errors.details}</p>
                        )}
                        <input
                            name="file"
                            type="file"
                            placeholder="Resume and Teaching Dossier Upload"
                            className="formBoxes files"
                            onChange={handleChange}
                        />
                        {errors.file && <p className="error">{errors.file}</p>}
                        <motion.button
                            className="contact-bottom-right-submit"
                            whileHover={{ scale: 1.05 }}
                            type="submit"
                        >
                            <p>{t("submit")}</p>
                            <FontAwesomeIcon
                                className="icon size"
                                icon={solidEnvelope}
                                size="50px"
                            />
                        </motion.button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Contact;